import styled from 'styled-components'

import { useNavigate } from '../hooks/useNavigate'

import { ColumnItem, RowBetween } from '../components/common'
import { StyledText, Text } from '../components/text'

import WebLogo from '../assets/web/logo-web.png'
import Qr from '../assets/web/web-qr.png'
import GooglePlay from '../assets/web/google-play.png'
import AppStore from '../assets/web/app-store.png'

export function WebAside() {
  const navigate = useNavigate()

  const goHome = () => {
    navigate('/home', { replace: true })
  }

  return (
    <Container $gap={32}>
      <Logo src={WebLogo} alt="artipio logo" onClick={goHome} />
      <ColumnItem $gap={16}>
        <Text size={24} weight={600} lineHeight={35}>
          YES24의
          <Text size={32} weight={700} lineHeight={41.6} block={true}>
            예술품 재테크 플랫폼
            <br />
            아티피오
          </Text>
        </Text>
        <Description size={16} weight={500} lineHeight={22.4} color="text_secondary">
          대한민국 대표 문화콘텐츠 플랫폼인 예스24의 자회사인 아티피오는, 누구나 예술을 향유하면서 안전하고 투명한 조각
          투자를 할 수 있는 예술품 재테크 플랫폼입니다.
        </Description>
      </ColumnItem>
      <ColumnItem $gap={16}>
        <QrCode src={Qr} alt="app download qr code" />
        <Text size={18} weight={500} color="text_secondary">
          간편하게 앱으로 작품을 만나보세요
        </Text>
      </ColumnItem>
      <RowBetween>
        <GooglePlayButton href="https://play.google.com/store/apps/details?id=com.artipio.app" target="_blank">
          <img src={GooglePlay} alt="google play button" />
        </GooglePlayButton>
        <AppStoreButton
          href="https://apps.apple.com/us/app/%EC%95%84%ED%8B%B0%ED%94%BC%EC%98%A4-artipio/id6572289602"
          target="_blank"
        >
          <img src={AppStore} alt="app store button" />
        </AppStoreButton>
      </RowBetween>
    </Container>
  )
}

const Container = styled(ColumnItem)`
  position: relative;
  width: 450px;
  height: 604px;
  margin-top: 22.5px;
  padding: 72px 40px 40px;
  border-radius: 24px;
  background-color: #ffffff;
`

const Logo = styled.img`
  position absolute;
  top: -50px;
  left: 40px;
  width: 90px;
  height: 90px;
`

const Description = styled(StyledText)`
  width: 356px;
`

const QrCode = styled.img`
  width: 132px;
  height: 132px;
`

const GooglePlayButton = styled.a`
  width: 182px;
  height: 54px;
`

const AppStoreButton = styled.a`
  width: 175px;
  height: 54px;
`
